export const createMeetting = `/api/oauth/tencent/meeting/create`;

export const queryMeetting = `/api/oauth/tencent/meeting/queryList`;
